import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import {
  GetDetectionMethodSummaryQuery,
  GetDetectionMethodSummaryQueryVariables,
} from '../../../shared/generated/graphql';

export const DETECTION_METHOD_SUMMARY_QUERY = gql`
  query getDetectionMethodSummary($tenant: String!) {
    getDetectionMethodSummary(tenant: $tenant) {
      detection_method
      total
      enabled
    }
  }
`;

export const useGetDetectionMethodSummary = (
  options: QueryHookOptions<
    GetDetectionMethodSummaryQuery,
    GetDetectionMethodSummaryQueryVariables
  >,
) => {
  return useQuery<
    GetDetectionMethodSummaryQuery,
    GetDetectionMethodSummaryQueryVariables
  >(DETECTION_METHOD_SUMMARY_QUERY, {
    ...options,
    fetchPolicy: 'cache-and-network',
    skip: !options.variables?.tenant,
  });
};
